import { QueryState } from 'src/app/core/models/query.model';
import { ITableColumn } from 'src/app/core/models/table.model';
import { createTokenQueryServiceInstance } from 'src/app/core/services/query.service';
import { SignalStoreConfig } from 'src/app/shared/functions/store.functions';
import { IParametro } from './parametri.model';

export const PARAMETRI_ENDPOINT = 'parametro';
export const PARAMETRI_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(PARAMETRI_ENDPOINT);

export const parametriStateConfig: SignalStoreConfig<QueryState<IParametro>> = {
  initState: {
    list: [],
    sort: {
      field: 'idAto',
      direction: 'asc'
    }
  }
}

export const PARAMETRI_COLUMNS: ITableColumn[] =[
  {
    name: 'id',
    label: 'ID',
    field: 'id',
    primaryKey: true
  },
  {
    name: 'nomenclatura',
    label: 'Nomenclatura',
    field: 'nomenclatura'
  },
  {
    name: 'parametro',
    label: 'Parametro',
    field: 'parametro',
  },
  {
    name: 'definizione',
    label: 'Definizione',
    field: 'definizione',
  },
  {
    name: 'precisioneDecimale',
    label: 'Precisione Decimale',
    field: 'precisioneDecimale',
    cell: (element: IParametro) => element.precisioneDecimale==1 ? 'non definita' : (!element.precisioneDecimale ? '1' : element.precisioneDecimale) ,
  },
  {
    name: 'unitaDiMisura',
    label: 'Unità di Misura',
    field: 'unitaDiMisura'
  },
  {
    name: 'note',
    label: 'Note',
    field: 'note'
  },
];

export const PARAMETRI_VISIBLECOLUMNS = [
  'parametro',
  'definizione',
  'precisioneDecimale',
  'unitaDiMisura',
  'note',
];
